import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import { canUseDOM } from "../../utils/can-use-dom";
var QUERY = '(prefers-reduced-motion: no-preference)';

var getInitialState = function getInitialState() {
  // eslint-disable-next-line react-hooks-ssr/react-hooks-global-ssr
  return canUseDOM() ? !window.matchMedia(QUERY).matches : true;
};

export function useReducedMotion() {
  var _useState = useState(getInitialState),
      _useState2 = _slicedToArray(_useState, 2),
      prefersReducedMotion = _useState2[0],
      setPrefersReducedMotion = _useState2[1];

  useEffect(function () {
    var mediaQueryList = window.matchMedia(QUERY);

    var listener = function listener(e) {
      setPrefersReducedMotion(!e.matches);
    };

    mediaQueryList.addListener(listener);
    return function () {
      mediaQueryList.removeListener(listener);
    };
  }, []);
  return prefersReducedMotion;
}